<div class="flex row">
    <img src="{{ asset.author.email | identicon | async }}" />
    <h2 class="email">{{ asset.author.email }}</h2>
</div>
